import _ from 'lodash';

export const isGoodCall = (call) => {
  const isLongEnough = call.duration_seconds > 300;
  const hasGoodLeadEmotion = ['joyful', 'appreciative', 'hopeful'].includes(
    _.reduce(_.keys(call?.summary?.emotions_breakdown), (r, k) =>
      (k !== 'neutral' && call.summary.emotions_breakdown[k] > call.summary.emotions_breakdown[r]) || 0 ? k : r
    )
  );
  return isLongEnough && hasGoodLeadEmotion;
};

export const isBadCall = (call) => {
  const isLongEnough = call.duration_seconds > 300;
  const hasBadLeadEmotion = ['disgusted', 'sad', 'frustrated', 'annoyed', 'disappointed', 'worried', 'skeptical'].includes(
    _.reduce(_.keys(call?.summary?.emotions_breakdown), (r, k) =>
      (k !== 'neutral' && call.summary.emotions_breakdown[k] > call.summary.emotions_breakdown[r]) || 0 ? k : r
    )
  );
  return isLongEnough && hasBadLeadEmotion;
};
